import { OperationResult } from '#common/stats';
export class GetRequestStatsContext {
    request;
    stats;
    blocksSucceeded = 0;
    blocksFailed = 0;
    startTime;
    logContext;
    constructor(request, stats) {
        this.request = request;
        this.stats = stats;
        this.logContext = { id: request.inodeId, start: request.startBlockId, limit: request.limitBlockId };
        this.startTime = stats.beginCall(this.logContext);
    }
    onGetSucceeded() {
        ++this.blocksSucceeded;
        if (this.isGetRequestCompleted()) {
            const outcome = this.blocksFailed > 0 ? OperationResult.FAILURE : OperationResult.SUCCESS;
            this.onRequestCompleted(outcome);
        }
    }
    onGetFailed() {
        ++this.blocksFailed;
        if (this.isGetRequestCompleted()) {
            this.onRequestFailed();
        }
    }
    onRequestFailed() {
        this.onRequestCompleted(OperationResult.FAILURE);
    }
    onRequestCompleted(outcome) {
        this.stats.endCall(this.startTime, outcome, this.logContext);
    }
    isGetRequestCompleted() {
        const blocksProcessed = this.blocksFailed + this.blocksSucceeded;
        const blocksRequested = this.request.limitBlockId - this.request.startBlockId;
        return blocksProcessed === blocksRequested;
    }
}
